import axios from "axios";
import { interceptApiError } from "../middlewares";

const timeout = process.env.VUE_APP_AUTH_TIMEOUT;

const authInstance = axios.create({
  baseURL: process.env.VUE_APP_AUTH_HOST,
  timeout: timeout * 1000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json"
  }
});

authInstance.interceptors.response.use(null, interceptApiError, {
  synchronous: true
});

export default authInstance;
